import {
	AppRouterKeys,
} from '@/shared/model/constants'

export const PAGE_TITLES: Record<string, string> = {
	[AppRouterKeys.CLUBS]:        'Клубы',
	[AppRouterKeys.CLUBS_CREATE]: 'Создать клуб',
	[AppRouterKeys.CLUB_DETAIL]:  'Клуб',
	[AppRouterKeys.GAMES]:        'Игры',
	[AppRouterKeys.GAME]:         'Игровой стол',
	[AppRouterKeys.ROOM]:         'Комната',
	[AppRouterKeys.PROFILE]:      'Профиль',
	[AppRouterKeys.MY_PROFILE]:   'Профиль',
	[AppRouterKeys.ROOM_CREATE]:  'Создать комнату',
	[AppRouterKeys.RULES]:        'Правила',
	[AppRouterKeys.RULES_DETAIL]: 'Правила',
}

export const MAIN_PAGES = [
	AppRouterKeys.HOME,
	AppRouterKeys.CLUBS,
	AppRouterKeys.GAMES,
] as const

export const HIDDEN_PAGES = [
] as const
